<template>
  <div class="beijing">
    <div class="xinxi">
      <div>
        <img style="width: 15px;height: 19px;" src="../assets/logo/1.png" alt="">
        <p style="font-size:12px;margin-left: 10px;">地址:山东省德州市临邑县临南镇</p>
      </div>
      <div>
        <img style="width: 19px;height: 19px;" src="../assets/logo/2.png" alt="">
        <p style="font-size:12px;margin-left: 10px;">电话:0534-4710111</p>
      </div>
      <div>
        <img style="width: 20px;height: 16px;" src="../assets/logo/3.png" alt="">
        <p style="font-size:12px;margin-left: 10px;">邮编:251500</p>
      </div>
      <div>
        <img style="width: 18px;height: 15px;" src="../assets/logo/4.png" alt="">
        <p style="font-size:12px;margin-left: 10px;">邮箱:lnzrmzf@dz.shandong.cn</p>
      </div>
    </div>

    <div class="banquans">
      <a style="color: #fff;" href="https://beian.miit.gov.cn/" target="_blank">鲁ICP备2023016604号</a>   临邑县临南镇人民政府
    </div>
  </div>
</template>
<script>
export default {
  name: "Footer",
  data() {
    return {
    }
  },
}
</script>

<style>
.beijing {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  height: 80px;
  background-size: 100% 100%;
}

.banquans{
  width: 100%;
  text-align: center;
  font-size: 13px;
  color: #FFF;
  margin-top: 10px;
}

.xinxi{
  height: 50px;
  display: flex;
  align-items: center;
  background-color: #52bb9d;
  background-size: 100% 100%;
}

.xinxi div {
  flex: 1;
}

.xinxi div img {
  float: left;
  margin-top: 3px;
}

.xinxi div p {
  float: left;
  line-height: 0px;
  color: #ffffff;
}
</style>
